import Item1 from '../../images/item1.png'
import Item2 from '../../images/item2.png'
import Item3 from '../../images/item3.jpg'
import Item4 from '../../images/item4.jpg'
import Item5 from '../../images/item5.jpg'
import Item6 from '../../images/item6.jpg'
import Item7 from '../../images/item7.jpg'
import Item8 from '../../images/item8.jpg'
import Item9 from '../../images/item9.jpg'
import Item10 from '../../images/item10.jpg'
import Item11 from '../../images/item11.jpg'
import Item12 from '../../images/item12.jpg'
import { ADD_TO_CART,REMOVE_ITEM,SUB_QUANTITY,ADD_QUANTITY,ADD_SHIPPING } from './types'


const initState = {
    items: [
        {id:1,title:'Dashboard & IoT', desc: "E-Kickscooter Dashboard & IoT; Communicating with the server and show the current speed.", price:150,img:Item1},
        {id:2,title:'Helmet Lock', desc: "Only applicable to specific E-Kickscooters; Lock the Helmet and controlled by the IoT", price:100,img: Item2},
        {id:3,title:'Helmet', desc: "Generally applicable to all of the vehicles; generally it is used with the Helmet Lock",price:20,img: Item3},
        {id:4,title:'Headlamp Trim Ring', desc: "For E-Kickscooter; Generally this will not be damaged easily, please double check before ordering", price:12,img:Item4},
        {id:5,title:'Head Main Shell', desc: "For E-Kickscooter; generally this will not be damaged easily, please double check before your order", price:80,img: Item5},
        {id:6,title:'Steering Tube', desc: "For E-Kickscooter; This is for the handlebar; normally it does not be damaged easily.",price:39,img: Item6},
        {id:7,title:'Handle Bar', desc: "For E-Kickscooter; Colour: Black; Suiable for all kinds of KRAC E-Kickscooters",price:36,img: Item7},
        {id:8,title:'Foot Mat', desc: "For E-Kickscooter; For the foot mat; this is for the middle one; please double check",price:55,img: Item8},
        {id:9,title:'Battery Box Lock', desc: "For TRAC E-Kickscooter; This is for the battery box; Check before you order it",price:90,img: Item9},
        {id:10,title:'Battery', desc: "For TRAC E-Kickscooter; 36V 13Ah, generally for 45-60 KM in labortary environment",price:500,img: Item10},
        {id:11,title:'Brake Lever', desc: "For TRAC E-Kickscooter; Black Brake Lever; please specific the direction of the E-Kickscooter",price:52,img: Item11},
        {id:12,title:'Kickstand', desc: "For TRAC E-Kickscooter; This kickstand uses the new materials; this will not be damaged easily",price:23,img: Item12}
    ],
    addedItems:[],
    total: 0
}
const cartReducer= (state = initState, action)=>{
   
    //INSIDE HOME COMPONENT
    if(action.type === ADD_TO_CART){
          let addedItem = state.items.find(item=> item.id === action.id)
          //check if the action id exists in the addedItems
         let existed_item= state.addedItems.find(item=> action.id === item.id)
         if(existed_item)
         {
            addedItem.quantity += 1 
             return{
                ...state,
                 total: state.total + addedItem.price,
                 items: initState.items
                  }
        }
         else{
            addedItem.quantity = 1;
            //calculating the total
            let newTotal = state.total + addedItem.price 
            
            return{
                ...state,
                addedItems: [...state.addedItems, addedItem],
                items: initState.items,
                total : newTotal
            }
            
        }
    }
    if(action.type === REMOVE_ITEM){
        let itemToRemove= state.addedItems.find(item=> action.id === item.id)
        let new_items = state.addedItems.filter(item=> action.id !== item.id)
        
        //calculating the total
        let newTotal = state.total - (itemToRemove.price * itemToRemove.quantity )
        console.log(itemToRemove)
        return{
            ...state,
            addedItems: new_items,
            items: initState.items,
            total: newTotal
        }
    }
    //INSIDE CART COMPONENT
    if(action.type=== ADD_QUANTITY){
        let addedItem = state.items.find(item=> item.id === action.id)
          addedItem.quantity += 1 
          let newTotal = state.total + addedItem.price
          return{
              ...state,
              total: newTotal
          }
    }
    if(action.type=== SUB_QUANTITY){  
        let addedItem = state.items.find(item=> item.id === action.id) 
        //if the qt == 0 then it should be removed
        if(addedItem.quantity === 1){
            let new_items = state.addedItems.filter(item=>item.id !== action.id)
            let newTotal = state.total - addedItem.price
            return{
                ...state,
                addedItems: new_items,
                items: initState.items,
                total: newTotal
            }
        }
        else {
            addedItem.quantity -= 1
            let newTotal = state.total - addedItem.price
            return{
                ...state,
                total: newTotal
            }
        }
        
    }

    if(action.type=== ADD_SHIPPING){
          return{
              ...state,
              total: state.total + 366,
              items: initState.items
          }
    }

    if(action.type=== 'SUB_SHIPPING'){
        return{
            ...state,
            total: state.total - 366,
            items: initState.items
        }
  }
    
  else{
    return state
    }
    
}

export default cartReducer
